import { ViewStream } from 'spyne';
import { CustomersTableTraits } from 'traits/customers/customers-table-traits.js';
import CustomersTableTmpl from './templates/customers-table-view.tmpl.html';

/**
 * Converted from app/ui/customers/table.tsx.
 *
 * The whole table is markup. Rows are generated by the template's
 * `{{#customers}}` sections — one for the below-md card stack, one for the
 * md-and-up table — because a customer row displays and does nothing else.
 * There is no per-row ViewStream and no slot to mount one into.
 *
 * That is the difference from the invoices table, whose rows carry update and
 * delete controls and are therefore views.
 *
 * The rows are shaped in the trait and handed to the template finished, so the
 * template holds no logic. `props.data.customers` is the resolved array; the
 * dump arrives as `props.data.acmeData.customers` from PageAcmeView.
 *
 * @param {Object} props
 * @param {Object} props.data
 * @param {String} [props.data.heading]
 * @param {String} [props.data.searchPlaceholder]
 * @param {Object} [props.data.acmeData]
 */
export class CustomersTableView extends ViewStream {
  constructor(props = {}) {
    const {
      heading = 'Customers',
      searchPlaceholder = 'Search customers...',
      acmeData,
    } = props.data || {};

    props.tagName = 'div';
    props.class = 'w-full';
    props.template = CustomersTableTmpl;
    props.channels = ['CHANNEL_ACME_CUSTOMERS'];
    props.traits = [CustomersTableTraits];
    props.data = {
      ...props.data,
      heading,
      searchPlaceholder,
      customers: CustomersTableTraits.customersTable$GetRows(
        acmeData?.customers,
      ),
    };

    super(props);
  }

  addActionListeners() {
    // The table shows the current PAGE of the current match, so it follows
    // the relayed VISIBLE_IDS action — the pagination ViewStream's slice —
    // rather than the raw LIST. The channel replays, and the relay is emitted
    // synchronously after every LIST, so the payload a late-born table
    // replays is exactly the page it should show.
    return [
      [
        'CHANNEL_ACME_CUSTOMERS_VISIBLE_IDS_EVENT',
        'customersTable$OnVisibleIds',
      ],
    ];
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {
    this.customersTable$OnRendered();
  }
}
